module.exports = __webpack_public_path__ + "img/guide_nolanovel.3ca470e2.png";